export class Manufacturer {
  id: Number = 0;
  name: String = '';
  expired: Boolean = false;

  is_edit: Boolean = false;

  init(id: Number, name: String, expired: Boolean) {
    this.id = id;
    this.name = name;
    this.expired = expired;
  }
}
